import React from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Button, Toolbar, Tooltip, Typography} from '@material-ui/core/';

import { MuiRouterLink } from '../CustomMui';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../actions';
import api from '../../utils/api';


export const Nav = ({dense=false, active}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const useStyles = makeStyles((theme) => ({
    logo: {
      marginRight: 'auto',
      width: dense ? 166 : 221,
      display: 'flex',
      alignItems: 'center',
      '& img': {
        width: '100%'
      }
    },
    infoLink: {
      fontSize: '25px',
      marginLeft: '25px'
    },
    infoLinkActive: {
      color: '#fff',
      backgroundColor: theme.palette.primary.hover,
      margin: -15,
      padding: 15,
      marginLeft: 10,
    },
    bar: {
      padding: '0 5px',
      color: theme.palette.neutral.med,
    },
    logout: {
      ...theme.overrides.MuiLink.root,
      padding: 0,
      background: 'transparent',
      textTransform: 'none',
      color: theme.palette.primary.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: 16,
      fontWeight: 600,
      '&:hover' :{
        textDecoration: 'underline',
        background: 'transparent',
        color: theme.palette.primary.hover,
      }
    }
  }));

  const handleLogout = () => {
    dispatch(setUser({}));
    api.logout();
    history.push('/login')
  }
  

  const classes = useStyles();
  
  return (
    <AppBar position="relative">
      <Toolbar variant={ dense ? 'dense' : 'regular' }>

        {/* Logo & Home link */}
        <MuiRouterLink to="/" className={classes.logo}>
          <img src={require("../../images/logo-interactive-builder.png")} alt="Pavilion Interactive Builder"/>
        </MuiRouterLink>

        {/* Current user */}
        <Typography component="p">{user.email}<span className={classes.bar}> | </span></Typography> 

        {/* Logout */}
        <Typography component={Button} className={classes.logout} onClick={handleLogout}>Logout</Typography>
        
        {/* About/Info link */}
        <Tooltip title="About" arrow interactive>
          <MuiRouterLink to={`/about`} className={`${classes.infoLink} ${active === 'about' ? classes.infoLinkActive : ''}`}><i className="fas fa-info-circle"></i></MuiRouterLink>
        </Tooltip>

      </Toolbar>
    </AppBar>
  )
}